<template>
    <div v-if="links.length > 0" :class="wrapperClass">
        <a
            v-for="legalLink in links"
            :key="'legal-link-' + legalLink.id"
            :class="linkClass"
            :href="legalLink.url"
            :rel="legalLink.target === '_blank' ? 'noopener noreferrer' : null"
            :target="legalLink.target || '_self'"
            @click="$emit('link-click', legalLink)"
        >
            {{ displayTitle(legalLink) }}
        </a>
    </div>
</template>

<script>
export default {
    name: "legal-links-menu",
    props: {
        wrapperClass: {
            type: String,
            required: false,
            default: '',
        },
        linkClass: {
            type: String,
            required: false,
            default: '',
        },
    },
    data() {
        return {
            links: [],
        };
    },
    mounted() {
        this.getLegalLinks();
    },
    methods: {
        getLegalLinks() {
            const self = this;

            axios.get('/api/legal-links').then(function (response) {
                self.links = Array.isArray(response.data) ? response.data : [];
            }).catch(function () {
                self.links = [];
            });
        },
        displayTitle(legalLink) {
            if (legalLink.title_mode === 'translation') {
                return this.translateIfExists(legalLink.translation_key) || legalLink.translation_key || '-';
            }

            return legalLink.custom_title || '-';
        },
        translateIfExists(key) {
            const text = String(key || '').trim();
            if (text === '') {
                return '';
            }

            if (typeof this.$te === 'function' && this.$te(text)) {
                return this.$t(text);
            }

            return text;
        },
    },
}
</script>
